import React from "react";

const Header = () =>{
    return (
      <div className="ui fixed menu">
        <div className="ui center aligned container ">
            <h2 className="headingcenter" >contact manager</h2>
        </div>
      </div>
    );
}

export default Header;